import { RolesService } from '@/backend/market'
import { RoleRepository } from '../../domain/repositories/RoleRepository'
import { RoleModel } from '../models/RoleModel'
import type { RoleEntity } from '../../domain/entities/RoleEntity'
import type { CreateUpdateRoleEntity } from '../../domain/entities/CreateUpdateRoleEntity'
import { CreateUpdateRoleModel } from '../models/CreateUpdateRoleModel'
import type { RoleFilterEntity } from '../../domain/entities/RoleFilterEntity'
import { RoleFilterModel } from '../models/RoleFilterModel'

export class RoleRepositoryImpl implements RoleRepository {
  async getRoles(filter?: RoleFilterEntity): Promise<RoleEntity[] | { error: true }> {
    try {
      const roleFilterModel = new RoleFilterModel(filter ?? ({} as RoleFilterEntity))
      const response = await RolesService.getRolesAdmin(roleFilterModel)
      const roleModels = response.items?.map((res) => new RoleModel(res)) ?? []
      return roleModels
    } catch {
      return { error: true }
    }
  }
  async createRole(roleData: CreateUpdateRoleEntity): Promise<{ success: true } | { error: true }> {
    const createUpdateRoleModel = new CreateUpdateRoleModel(roleData)
    try {
      await RolesService.postRoleAdmin({
        requestBody: createUpdateRoleModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateRole(
    id: number,
    roleData: CreateUpdateRoleEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateRoleModel = new CreateUpdateRoleModel(roleData)
    try {
      await RolesService.putRoleAdmin({
        id,
        requestBody: createUpdateRoleModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteRole(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await RolesService.deleteRoleAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
